var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;fill-rule:evenodd;}")),React.createElement("path",{"className":"a","d":"M13,1.825a8.814,8.814,0,1,1-8.377,0l.466.62a8.048,8.048,0,1,0,7.445,0L13,1.825ZM9.2,0V11.364L12.07,7.835l.577.51L8.814,13.03,4.982,8.354l.565-.52,2.884,3.532V0Z","key":1})]);
}

Download.defaultProps = {"width":"17.629","height":"18.395","viewBox":"0 0 17.629 18.395"};

module.exports = Download;

Download.default = Download;
